import Layout from "../../components/mainPage/Layout";
import ModeCalculation from "../../images/systemComponents/ModeCalculation.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Расчет режима
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Расчет режима</b> на базе CIM (Common Information Model) в сочетании с SCADA NPT Expert, отвечающей за сбор данных и управление процессами,  становится важным инструментом для анализа, оптимизации и управления энергосистемами.
                    </p>
                    <img
                        src={ModeCalculation}
                        className="mb-4  w-100"
                        alt="Расчет режима"
                    />

                    <p>Основные задачи, которые он позволяет решать, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Моделирование и анализ установившихся режимов работы сети</b>
                            <ul>
                                <li>Расчет режима позволяет моделировать и анализировать установившиеся режимы работы энергосистемы, включая:
                                    <ul>
                                        <li>Распределение напряжений и токов в узлах сети.</li>
                                        <li>Перетоки активной и реактивной мощности.</li>
                                        <li>Потери мощности в элементах сети.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Оптимизация управления нагрузкой</b>
                            <ul>
                                <li>На основе данных, полученных от SCADA NPT Expert, расчет режима позволяет:
                                    <ul>
                                        <li>Перераспределять нагрузку между узлами сети.</li>
                                        <li>Минимизировать потери энергии.</li>
                                        <li>Планировать оптимальные схемы переключений.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Прогнозирование и предотвращение аварийных ситуаций</b>
                            <ul>
                                <li>Расчет режима позволяет моделировать различные сценарии работы сети, включая отключение ключевых элементов сети в послеаварийном режиме.

                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Поддержка принятия решений</b>
                            <ul>
                                <li>Расчет режима на базе CIM предоставляет операторам SCADA NPT Expert
                                    данные для принятия обоснованных решений, таких как:
                                    <ul>
                                        <li>Оптимизация схем переключений.</li>
                                        <li>Прогнозирование последствий изменений в сети.</li>

                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Автоматизация процессов</b>
                            <ul>
                                <li>В сочетании со SCADA NPT Expert расчет режима позволяет автоматизировать такие процессы, как:
                                    <ul>
                                        <li>Предотвращение и локализация аварий.</li>
                                        <li>Восстановление схемы после аварийных переключений.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>


                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'Расчет режима',
    description: 'Расчет режима на базе CIM (Common Information Model) в сочетании с SCADA NPT Expert, отвечающей за сбор данных и управление процессами,  становится важным инструментом для анализа, оптимизации и управления энергосистемами.'
}